import {
  Component,
  ChangeDetectionStrategy,
  computed,
  inject,
  input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { CartService } from '../../../core/services/cart/cart.service';
import { type Product } from '../../../core/services/products/product.interface';
import { ButtonDirective } from '../../directives/button.directive';

@Component({
  selector: 'app-cart-controls',
  templateUrl: './cart-controls.component.html',
  imports: [MatIconModule, ButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartControlsComponent {
  private readonly cartService = inject(CartService);

  readonly product = input.required<Product>();

  readonly quantity = computed(() => {
    const item = this.cartService
      .items()
      .find((i) => i.product.CodProd === this.product().CodProd);
    return item?.quantity ?? 0;
  });

  updateQuantity(value: string): void {
    const trimmedValue = value.trim();

    if (trimmedValue === '') {
      this.cartService.removeItem(this.product().CodProd);
      return;
    }

    const quantity = Number(trimmedValue) || 0;
    this.cartService.updateQuantity(
      this.product().CodProd,
      quantity,
      this.product().Existen,
    );
  }

  onDecrease(): void {
    const currentQuantity = this.quantity();
    if (currentQuantity > 0) {
      this.cartService.updateQuantity(
        this.product().CodProd,
        currentQuantity - 1,
      );
    }
  }

  onIncrease(): void {
    this.cartService.addItem(this.product());
  }
}
